import { render, staticRenderFns } from "./Group.vue?vue&type=template&id=c705b52e&scoped=true"
import script from "./Group.vue?vue&type=script&lang=js"
export * from "./Group.vue?vue&type=script&lang=js"
import style0 from "./Group.vue?vue&type=style&index=0&id=c705b52e&prod&lang=scss&scoped=true"
import style1 from "./Group.vue?vue&type=style&index=1&id=c705b52e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c705b52e",
  null
  
)

export default component.exports